import apiClient from '@app/config/axios.config'
import { Endpoint } from '@app/config/endpoints'
import type {
  ProfileRiskRequest,
  ProfileRiskWidgetKey,
  RiskProfileQueryParams,
  RiskProfileResponse,
} from '../types/riskProfile.types'

export type useRiskProfileRequestOptions = {
  queryParams: RiskProfileQueryParams | null
  widget: ProfileRiskWidgetKey
}

export const RISK_PROFILE_QUERY_KEY = 'risk-profile'

export const fetchProfileRisk = async (
  request: ProfileRiskRequest,
): Promise<RiskProfileResponse> => {
  const { data } = await apiClient.post<RiskProfileResponse>(Endpoint.riskProfile, request)
  return data
}
